import React, { useState, useEffect } from 'react';
import { getBestImageUrl, getAuthenticatedStorageUrl } from '../utils/image';

const AuthenticatedImage = ({ item, onViewImage, onRemoveImage }) => {
  const [imageUrl, setImageUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const loadImage = async () => {
      try {
        setIsLoading(true);
        setHasError(false);
        const bestImageUrl = getBestImageUrl(item, null);
        if (item.images?.primary?.isOptimistic) {
          setImageUrl(bestImageUrl);
          setIsLoading(false);
          return;
        }
        const finalUrl = await getAuthenticatedStorageUrl(bestImageUrl);
        setImageUrl(finalUrl);

        setIsLoading(false);
      } catch (error) {
        console.error('🖼️ [Image Load Error] Failed to load image:', error);
        setHasError(true);
        setIsLoading(false);
      }
    };

    loadImage();
  }, [item]);

  const handleImageClick = () => {
    if (imageUrl) {
      onViewImage(imageUrl, item);
    }
  };

  const handleImageError = (e) => {
    console.error('🖼️ [List Item Image Error] Failed to load image:', e.target.src);
    console.error('🖼️ [List Item Image Error] Item:', item.id, item.content);
    setHasError(true);
  };

  if (isLoading) {
    return (
      <div className="list-item-image-container">
        <div className="list-item-image-loading">Loading...</div>
      </div>
    );
  }

  if (hasError || !imageUrl) {
    return (
      <div className="list-item-image-container">
        <div className="list-item-image-error">❌</div>
      </div>
    );
  }

  return (
    <div className="list-item-image-container">
      <img
        src={imageUrl}
        alt="Item image"
        className="list-item-image"
        onClick={handleImageClick}
        onError={handleImageError}
      />
      <button
        className="list-item-image-remove"
        onClick={(e) => {
          e.stopPropagation();
          onRemoveImage();
        }}
        title="Remove image"
      >
        ×
      </button>
    </div>
  );
};

export default AuthenticatedImage;
